module.exports = __webpack_public_path__ + "static/sec5-bg-f85494a2b2af37df71d10956e219a329.jpg";